import { ComponentType, lazy } from 'react'
import { reloadOnChunkError } from 'utility/reloadOnChunkError'

type ILazyModuleFactory<TComponent extends ComponentType<any>> = () => Promise<{
  default: TComponent
}>

export const loadModuleWithReloadOnChunkError = async <TComponent extends ComponentType<any>>(
  factory: ILazyModuleFactory<TComponent>
): Promise<{ default: TComponent }> => {
  try {
    const module = await factory()

    if (!module?.default) {
      throw new Error('Lazy-loaded module resolved without a default export')
    }

    return module
  } catch (error) {
    // The never-resolving promise keeps the Suspense fallback visible until
    // the reload started by reloadOnChunkError completes, instead of letting
    // React rethrow the chunk error to Bugsnag.
    if (reloadOnChunkError()) return new Promise<never>(() => {})

    throw error
  }
}

export const lazyWithReload = <TComponent extends ComponentType<any>>(
  factory: ILazyModuleFactory<TComponent>
) => lazy(() => loadModuleWithReloadOnChunkError(factory))
